import Vue from 'vue'
import SnackbarVue from '@/components/globals/basics/Snackbar.vue'

const SnackbarConstructor = Vue.extend(SnackbarVue)
let instance: Vue | undefined

const initInstance = () => {
  return new SnackbarConstructor({
    el: document.createElement('div'),
  })
}

export interface SnackbarOption {
  text: string
  link?: { to: string; text: string }
}

const snackbar = (option: SnackbarOption): void => {
  if (!instance) {
    instance = initInstance()
  }
  instance.$slots.default = [instance.$createElement('p', option.text)]
  instance.$props.link = option.link
  instance.$data.showSnackbar = true
}
export default snackbar
